import React from 'react';
import { Link } from 'react-router-dom';
import PagedEntitiesList from '../../common/components/PagedEntitiesList';
import { ConfirmationButton } from '../../common/components/formControls';
import ui from '../../common/services/ui';
import { withTranslation } from 'react-i18next';

const List = ({ onDelete, isReadonly, parentId, paymentId, t, ...rest }) => {
	const columns = [
		{
			header: t('IndividualConsultationDocument_Name'),
			accessor: 'name',
			sortable: true,
			cell: (name, row) => (row.document ? <a target='blank' href={row.document.url}>{name || row.type || row.document.friendlyFilename}</a> : <span>{name}</span>)
		},
		{
			header: t('IndividualConsultationDocument_Type'),
			accessor: 'type',
			cell: (type) => type != 'Unknown' ? t(`PaymentHistoryDocumentType_${type}`) : '',
			sortable: true
		},
		{
			header: t('Common_Created'),
			accessor: 'created',
			sortable: true,
			cell: created => ui.formatDateTime(created)
		},
		{
			header: t('Common_Actions'),
			accessor: 'id',
			cell: (id) => <span>
				<ConfirmationButton
					onConfirmation={() => onDelete(id)}
					confirmationTitle={t('IndividualConsultationDocument_DeleteConfirmationTitle')}
					confirmationMessage={t('IndividualConsultationDocument_DeleteConfirmationMessage')}
					displayType={'inline'}
					style={{ marginLeft: '5px' }}
					label={t('Common_Delete')}
					disabled={isReadonly}
				/>
			</span>
		}
	];

	return (
		<div>
			<div className={isReadonly ? 'hidden' : ''} style={{ marginBottom: '10px' }}>
				<Link to={`/individualConsultations/${paymentId}/${parentId}/individualConsultationDocuments/newIndividualProgram`} className='btn btn-success mr-1'>{t('IndividualConsultationDocument_NewIndividualProgram')}</Link>
				<Link to={`/individualConsultations/${paymentId}/${parentId}/individualConsultationDocuments/newAnalysis`} className='btn btn-success'>{t('IndividualConsultationDocument_NewAnalysis')}</Link>
			</div>
			<PagedEntitiesList columns={columns} {...rest} />
		</div>
	);
};

export default withTranslation()(List);